import { render } from "./Trademark.vue?vue&type=template&id=757107a5&scoped=true"
import script from "./Trademark.vue?vue&type=script&lang=js"
export * from "./Trademark.vue?vue&type=script&lang=js"

import "./Trademark.vue?vue&type=style&index=0&id=757107a5&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-757107a5"]])

export default __exports__